<template>
  <div>
    <template v-if="!$empresa.portalIndicadorAgendaPagamento && condicaoImprimirParcelas">
      <v-list-item @click="modalPropostaParcela">
        <v-list-item-icon><v-icon>fa fa-barcode</v-icon></v-list-item-icon>
        <v-list-item-title>Imprimir Parcelas</v-list-item-title>
      </v-list-item>
    </template>

    <template v-if="$empresa.portalIndicadorAgendaPagamento && model.Situacao >= $aux.SituacaoPropostaEnum.Finalizada">
      <v-list-item @click="modalAgendaPagamento">
        <v-list-item-icon><v-icon>fa fa-barcode</v-icon></v-list-item-icon>
        <v-list-item-title>Agenda de Pagamento</v-list-item-title>
      </v-list-item>
    </template>

    <ModalPropostaParcela ref="modalPropostaParcela"></ModalPropostaParcela>
    <ModalAgendaPagamento ref="modalAgendaPagamento"></ModalAgendaPagamento>
  </div>
</template>

<script>
export default {
  components: {
    ModalPropostaParcela: () => import('./ModalPropostaParcela'),
    ModalAgendaPagamento: () => import('./ModalAgendaPagamento')
  },
  props: {
    value: null,
    condicaoImprimirParcelas: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value;
      }
    },
  },
  methods: {
    modalPropostaParcela (e) {
      e.preventDefault();
      this.$refs.modalPropostaParcela.openModal(this.model);
    },
    modalAgendaPagamento (e) {
      e.preventDefault();
      this.$refs.modalAgendaPagamento.openModal(this.model.Codigo);
    },
  }
}
</script>
